import { EnvironmentProviders } from '@angular/core';
import { provideIotPlatformApplicationState, provideIotPlatformBusinessProfileWhenReadRuleOnDeviceConfiguratorConceptState } from '@iot-platform/data-access';
import { provideEffects } from '@ngrx/effects';
import { combineReducers, createFeature, provideState } from '@ngrx/store';
import { DirectoryEffects } from '../effects/directory.effects';
import { directoryFeature, DirectoryState } from './directory.reducer';

export interface ApplicationState {
  [directoryFeature.name]: DirectoryState;
}

export const applicationFeatures = createFeature<string, ApplicationState>({
  name: 'dalia-application',
  reducer: combineReducers({
    [directoryFeature.name]: directoryFeature.reducer
  })
});

export function provideDaliaApplicationState(): EnvironmentProviders[] {
  return [provideState(applicationFeatures.name, applicationFeatures.reducer), provideEffects(DirectoryEffects)].concat(
    provideIotPlatformApplicationState(),
    provideIotPlatformBusinessProfileWhenReadRuleOnDeviceConfiguratorConceptState()
  );
}
